import { v4 as uuidv4 } from 'uuid';

const APPROVAL_KEY = Object.freeze({
  ASSIGNED: 'ASSIGNED',
  UNASSIGNED: 'UNASSIGNED',
});

const DUE_DILIGENCE_STATUS = Object.freeze({
  CLOSED: 'CLOSED',
  PENDING: 'PENDING',
  WORK_IN_PROGRESS: 'WORK_IN_PROGRESS',
});

const RISK_LEVEL = Object.freeze({
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  SEVERE: 'SEVERE',
});

const OPENING_ACCOUNT_REASONS = Object.freeze([
  { id: uuidv4(), value: 'Accredito stipendio/pensione', risk_score: 1 },
  { id: uuidv4(), value: 'Risparmio personale', risk_score: 1 },
  { id: uuidv4(), value: 'Gestione incassi aziendali', risk_score: 3 },
  { id: uuidv4(), value: 'Investimenti finanziari', risk_score: 3 },
  { id: uuidv4(), value: 'Attività di trading/criptovalute', risk_score: 5 },
  {
    id: uuidv4(),
    value: 'Trasferimenti internazionali frequenti',
    risk_score: 5,
  },
]);

const WORK_TYPES = Object.freeze([
  { id: uuidv4(), value: 'Disoccupato/Casalinga', risk_score: 3 },
  { id: uuidv4(), value: 'Studente', risk_score: 3 },
  { id: uuidv4(), value: 'Pensionato', risk_score: 1 },
  { id: uuidv4(), value: 'Lavoratore dipendente (privato)', risk_score: 1 },
  { id: uuidv4(), value: 'Lavoratore dipendente (pubblico)', risk_score: 1 },
  { id: uuidv4(), value: 'Libero professionista/Autonomo', risk_score: 3 },
  { id: uuidv4(), value: 'Imprenditore/Dirigente d\'azienda', risk_score: 3 },
  { id: uuidv4(), value: 'Persona Politicamente Esposta (PEP)', risk_score: 5 },
]);

const WORK_SECTORS = Object.freeze([
  {
    id: uuidv4(),
    value: 'Pubblica amministrazione/Servizi governativi',
    risk_score: 1,
  },
  { id: uuidv4(), value: 'Istruzione/Cultura', risk_score: 1 },
  { id: uuidv4(), value: 'Sanità/Servizi sociali', risk_score: 1 },
  {
    id: uuidv4(),
    value: 'Servizi finanziari/regolamentati (es. banche, assicurazioni)',
    risk_score: 1,
  },
  {
    id: uuidv4(),
    value: 'Commercio al dettaglio/Servizi commerciali',
    risk_score: 3,
  },
  { id: uuidv4(), value: 'Industria manifatturiera/Produzione', risk_score: 3 },
  { id: uuidv4(), value: 'Costruzioni/Edilizia', risk_score: 3 },
  {
    id: uuidv4(),
    value: 'Commercio all\'ingrosso/Import-Export',
    risk_score: 3,
  },
  {
    id: uuidv4(),
    value: 'Studi professionali (avvocati, commercialisti)',
    risk_score: 3,
  },
  {
    id: uuidv4(),
    value: 'Agenzia immobiliare/Costruzione immobili',
    risk_score: 3,
  },
  { id: uuidv4(), value: 'Organizzazione non-profit/ONG', risk_score: 3 },
  { id: uuidv4(), value: 'Giochi e Scommesse/Casinò', risk_score: 5 },
  {
    id: uuidv4(),
    value: 'Compravendita oro, gioielli o oggetti di valore',
    risk_score: 5,
  },
  { id: uuidv4(), value: 'Arte/Antiquariato', risk_score: 5 },
  {
    id: uuidv4(),
    value: 'Commercio di armi o materiali sensibili',
    risk_score: 5,
  },
  {
    id: uuidv4(),
    value: 'Money transfer/Cambio valute/Crypto exchange',
    risk_score: 5,
  },
  {
    id: uuidv4(),
    value: 'Ristorazione/Bar (attività cash-intensive)',
    risk_score: 5,
  },
  { id: uuidv4(), value: 'Intrattenimento/Night club', risk_score: 5 },
]);

const GEOGRAPHICAL_AREA = Object.freeze([
  { id: uuidv4(), code: 'AF', name: 'Afghanistan', risk_score: 5 },
  { id: uuidv4(), code: 'AL', name: 'Albania', risk_score: 3 },
  { id: uuidv4(), code: 'DZ', name: 'Algeria', risk_score: 5 },
  { id: uuidv4(), code: 'AD', name: 'Andorra', risk_score: 1 },
  { id: uuidv4(), code: 'AO', name: 'Angola', risk_score: 5 },
  { id: uuidv4(), code: 'AG', name: 'Antigua e Barbuda', risk_score: 5 },
  { id: uuidv4(), code: 'SA', name: 'Arabia Saudita', risk_score: 3 },
  { id: uuidv4(), code: 'AR', name: 'Argentina', risk_score: 1 },
  { id: uuidv4(), code: 'AM', name: 'Armenia', risk_score: 1 },
  { id: uuidv4(), code: 'AU', name: 'Australia', risk_score: 1 },
  { id: uuidv4(), code: 'AT', name: 'Austria', risk_score: 1 },
  { id: uuidv4(), code: 'AZ', name: 'Azerbaigian', risk_score: 1 },
  { id: uuidv4(), code: 'BS', name: 'Bahamas', risk_score: 5 },
  { id: uuidv4(), code: 'BH', name: 'Bahrein', risk_score: 1 },
  { id: uuidv4(), code: 'BD', name: 'Bangladesh', risk_score: 3 },
  { id: uuidv4(), code: 'BB', name: 'Barbados', risk_score: 5 },
  { id: uuidv4(), code: 'BE', name: 'Belgio', risk_score: 1 },
  { id: uuidv4(), code: 'BZ', name: 'Belize', risk_score: 3 },
  { id: uuidv4(), code: 'BJ', name: 'Benin', risk_score: 3 },
  { id: uuidv4(), code: 'BT', name: 'Bhutan', risk_score: 1 },
  { id: uuidv4(), code: 'BY', name: 'Bielorussia', risk_score: 5 },
  { id: uuidv4(), code: 'MM', name: 'Birmania/Myanmar', risk_score: 5 },
  { id: uuidv4(), code: 'BO', name: 'Bolivia', risk_score: 3 },
  { id: uuidv4(), code: 'BA', name: 'Bosnia ed Erzegovina', risk_score: 3 },
  { id: uuidv4(), code: 'BW', name: 'Botswana', risk_score: 1 },
  { id: uuidv4(), code: 'BR', name: 'Brasile', risk_score: 3 },
  { id: uuidv4(), code: 'BN', name: 'Brunei', risk_score: 1 },
  { id: uuidv4(), code: 'BG', name: 'Bulgaria', risk_score: 1 },
  { id: uuidv4(), code: 'BF', name: 'Burkina Faso', risk_score: 5 },
  { id: uuidv4(), code: 'BI', name: 'Burundi', risk_score: 3 },
  { id: uuidv4(), code: 'KH', name: 'Cambogia', risk_score: 3 },
  { id: uuidv4(), code: 'CM', name: 'Camerun', risk_score: 5 },
  { id: uuidv4(), code: 'CA', name: 'Canada', risk_score: 1 },
  { id: uuidv4(), code: 'CV', name: 'Capo Verde', risk_score: 1 },
  { id: uuidv4(), code: 'CF', name: 'Repubblica Centrafricana', risk_score: 3 },
  { id: uuidv4(), code: 'TD', name: 'Ciad', risk_score: 3 },
  { id: uuidv4(), code: 'CL', name: 'Cile', risk_score: 1 },
  { id: uuidv4(), code: 'CN', name: 'Cina', risk_score: 3 },
  { id: uuidv4(), code: 'CY', name: 'Cipro', risk_score: 1 },
  { id: uuidv4(), code: 'CO', name: 'Colombia', risk_score: 3 },
  { id: uuidv4(), code: 'KM', name: 'Comore', risk_score: 1 },
  { id: uuidv4(), code: 'CG', name: 'Congo', risk_score: 3 },
  {
    id: uuidv4(),
    code: 'CD',
    name: 'Repubblica Democratica del Congo',
    risk_score: 5,
  },
  { id: uuidv4(), code: 'KR', name: 'Corea del Sud', risk_score: 1 },
  { id: uuidv4(), code: 'KP', name: 'Corea del Nord', risk_score: 5 },
  { id: uuidv4(), code: 'CI', name: 'Costa d\'Avorio', risk_score: 5 },
  { id: uuidv4(), code: 'CR', name: 'Costa Rica', risk_score: 1 },
  { id: uuidv4(), code: 'HR', name: 'Croazia', risk_score: 1 },
  { id: uuidv4(), code: 'CU', name: 'Cuba', risk_score: 5 },
  { id: uuidv4(), code: 'DK', name: 'Danimarca', risk_score: 1 },
  { id: uuidv4(), code: 'DM', name: 'Dominica', risk_score: 1 },
  { id: uuidv4(), code: 'EC', name: 'Ecuador', risk_score: 1 },
  { id: uuidv4(), code: 'EG', name: 'Egitto', risk_score: 3 },
  { id: uuidv4(), code: 'SV', name: 'El Salvador', risk_score: 3 },
  { id: uuidv4(), code: 'AE', name: 'Emirati Arabi Uniti', risk_score: 3 },
  { id: uuidv4(), code: 'ER', name: 'Eritrea', risk_score: 3 },
  { id: uuidv4(), code: 'EE', name: 'Estonia', risk_score: 1 },
  { id: uuidv4(), code: 'ET', name: 'Etiopia', risk_score: 3 },
  { id: uuidv4(), code: 'FJ', name: 'Figi', risk_score: 3 },
  { id: uuidv4(), code: 'PH', name: 'Filippine', risk_score: 3 },
  { id: uuidv4(), code: 'FI', name: 'Finlandia', risk_score: 1 },
  { id: uuidv4(), code: 'FR', name: 'Francia', risk_score: 1 },
  { id: uuidv4(), code: 'GA', name: 'Gabon', risk_score: 3 },
  { id: uuidv4(), code: 'GM', name: 'Gambia', risk_score: 1 },
  { id: uuidv4(), code: 'GE', name: 'Georgia', risk_score: 1 },
  { id: uuidv4(), code: 'DE', name: 'Germania', risk_score: 1 },
  { id: uuidv4(), code: 'GH', name: 'Ghana', risk_score: 3 },
  { id: uuidv4(), code: 'JM', name: 'Giamaica', risk_score: 3 },
  { id: uuidv4(), code: 'JP', name: 'Giappone', risk_score: 1 },
  { id: uuidv4(), code: 'GI', name: 'Gibilterra', risk_score: 1 },
  { id: uuidv4(), code: 'DJ', name: 'Gibuti', risk_score: 1 },
  { id: uuidv4(), code: 'JO', name: 'Giordania', risk_score: 3 },
  { id: uuidv4(), code: 'GR', name: 'Grecia', risk_score: 1 },
  { id: uuidv4(), code: 'GD', name: 'Grenada', risk_score: 5 },
  { id: uuidv4(), code: 'GT', name: 'Guatemala', risk_score: 3 },
  { id: uuidv4(), code: 'GN', name: 'Guinea', risk_score: 3 },
  { id: uuidv4(), code: 'GW', name: 'Guinea-Bissau', risk_score: 3 },
  { id: uuidv4(), code: 'GQ', name: 'Guinea Equatoriale', risk_score: 3 },
  { id: uuidv4(), code: 'GY', name: 'Guyana', risk_score: 1 },
  { id: uuidv4(), code: 'HT', name: 'Haiti', risk_score: 5 },
  { id: uuidv4(), code: 'HN', name: 'Honduras', risk_score: 3 },
  { id: uuidv4(), code: 'IN', name: 'India', risk_score: 3 },
  { id: uuidv4(), code: 'ID', name: 'Indonesia', risk_score: 3 },
  { id: uuidv4(), code: 'IR', name: 'Iran', risk_score: 5 },
  { id: uuidv4(), code: 'IQ', name: 'Iraq', risk_score: 5 },
  { id: uuidv4(), code: 'IE', name: 'Irlanda', risk_score: 1 },
  { id: uuidv4(), code: 'IS', name: 'Islanda', risk_score: 1 },
  { id: uuidv4(), code: 'MH', name: 'Isole Marshall', risk_score: 3 },
  { id: uuidv4(), code: 'SB', name: 'Isole Salomone', risk_score: 1 },
  { id: uuidv4(), code: 'IL', name: 'Israele', risk_score: 1 },
  { id: uuidv4(), code: 'IT', name: 'Italia', risk_score: 1 },
  { id: uuidv4(), code: 'KW', name: 'Kuwait', risk_score: 3 },
  { id: uuidv4(), code: 'LA', name: 'Laos', risk_score: 3 },
  { id: uuidv4(), code: 'LS', name: 'Lesotho', risk_score: 1 },
  { id: uuidv4(), code: 'LV', name: 'Lettonia', risk_score: 1 },
  { id: uuidv4(), code: 'LB', name: 'Libano', risk_score: 5 },
  { id: uuidv4(), code: 'LR', name: 'Liberia', risk_score: 3 },
  { id: uuidv4(), code: 'LY', name: 'Libia', risk_score: 3 },
  { id: uuidv4(), code: 'LI', name: 'Liechtenstein', risk_score: 5 },
  { id: uuidv4(), code: 'LT', name: 'Lituania', risk_score: 1 },
  { id: uuidv4(), code: 'LU', name: 'Lussemburgo', risk_score: 1 },
  { id: uuidv4(), code: 'MG', name: 'Madagascar', risk_score: 3 },
  { id: uuidv4(), code: 'MW', name: 'Malawi', risk_score: 1 },
  { id: uuidv4(), code: 'MV', name: 'Maldive', risk_score: 1 },
  { id: uuidv4(), code: 'MY', name: 'Malesia', risk_score: 3 },
  { id: uuidv4(), code: 'ML', name: 'Mali', risk_score: 5 },
  { id: uuidv4(), code: 'MT', name: 'Malta', risk_score: 1 },
  { id: uuidv4(), code: 'MA', name: 'Marocco', risk_score: 3 },
  { id: uuidv4(), code: 'MU', name: 'Mauritius', risk_score: 1 },
  { id: uuidv4(), code: 'MX', name: 'Messico', risk_score: 3 },
  { id: uuidv4(), code: 'MC', name: 'Monaco', risk_score: 1 },
  { id: uuidv4(), code: 'MN', name: 'Mongolia', risk_score: 1 },
  { id: uuidv4(), code: 'ME', name: 'Montenegro', risk_score: 1 },
  { id: uuidv4(), code: 'MZ', name: 'Mozambico', risk_score: 5 },
  { id: uuidv4(), code: 'MM', name: 'Myanmar', risk_score: 5 },
  { id: uuidv4(), code: 'NA', name: 'Namibia', risk_score: 5 },
  { id: uuidv4(), code: 'NP', name: 'Nepal', risk_score: 1 },
  { id: uuidv4(), code: 'NI', name: 'Nicaragua', risk_score: 1 },
  { id: uuidv4(), code: 'NE', name: 'Niger', risk_score: 3 },
  { id: uuidv4(), code: 'NG', name: 'Nigeria', risk_score: 5 },
  { id: uuidv4(), code: 'NO', name: 'Norvegia', risk_score: 1 },
  { id: uuidv4(), code: 'NZ', name: 'Nuova Zelanda', risk_score: 1 },
  { id: uuidv4(), code: 'OM', name: 'Oman', risk_score: 3 },
  { id: uuidv4(), code: 'NL', name: 'Paesi Bassi', risk_score: 1 },
  { id: uuidv4(), code: 'PK', name: 'Pakistan', risk_score: 3 },
  { id: uuidv4(), code: 'PW', name: 'Palau', risk_score: 3 },
  { id: uuidv4(), code: 'PA', name: 'Panamá', risk_score: 5 },
  { id: uuidv4(), code: 'PG', name: 'Papua Nuova Guinea', risk_score: 1 },
  { id: uuidv4(), code: 'PY', name: 'Paraguay', risk_score: 1 },
  { id: uuidv4(), code: 'PE', name: 'Perù', risk_score: 3 },
  { id: uuidv4(), code: 'PL', name: 'Polonia', risk_score: 1 },
  { id: uuidv4(), code: 'PT', name: 'Portogallo', risk_score: 1 },
  { id: uuidv4(), code: 'MC', name: 'Principato di Monaco', risk_score: 1 },
  { id: uuidv4(), code: 'QA', name: 'Qatar', risk_score: 3 },
  { id: uuidv4(), code: 'GB', name: 'Regno Unito', risk_score: 1 },
  { id: uuidv4(), code: 'CZ', name: 'Repubblica Ceca', risk_score: 1 },
  { id: uuidv4(), code: 'CF', name: 'Repubblica Centrafricana', risk_score: 3 },
  { id: uuidv4(), code: 'MD', name: 'Repubblica di Moldova', risk_score: 1 },
  { id: uuidv4(), code: 'RO', name: 'Romania', risk_score: 1 },
  { id: uuidv4(), code: 'RW', name: 'Ruanda', risk_score: 1 },
  { id: uuidv4(), code: 'RU', name: 'Russia', risk_score: 5 },
  { id: uuidv4(), code: 'KN', name: 'Saint Kitts e Nevis', risk_score: 1 },
  { id: uuidv4(), code: 'LC', name: 'Saint Lucia', risk_score: 5 },
  {
    id: uuidv4(),
    code: 'VC',
    name: 'Saint Vincent e Grenadine',
    risk_score: 1,
  },
  { id: uuidv4(), code: 'WS', name: 'Samoa', risk_score: 5 },
  { id: uuidv4(), code: 'SM', name: 'San Marino', risk_score: 1 },
  { id: uuidv4(), code: 'ST', name: 'São Tomé e Príncipe', risk_score: 1 },
  { id: uuidv4(), code: 'SN', name: 'Senegal', risk_score: 5 },
  { id: uuidv4(), code: 'RS', name: 'Serbia', risk_score: 1 },
  { id: uuidv4(), code: 'SC', name: 'Seychelles', risk_score: 1 },
  { id: uuidv4(), code: 'SL', name: 'Sierra Leone', risk_score: 3 },
  { id: uuidv4(), code: 'SG', name: 'Singapore', risk_score: 1 },
  { id: uuidv4(), code: 'SY', name: 'Siria', risk_score: 5 },
  { id: uuidv4(), code: 'SK', name: 'Slovacchia', risk_score: 1 },
  { id: uuidv4(), code: 'SI', name: 'Slovenia', risk_score: 1 },
  { id: uuidv4(), code: 'SO', name: 'Somalia', risk_score: 5 },
  { id: uuidv4(), code: 'ES', name: 'Spagna', risk_score: 1 },
  { id: uuidv4(), code: 'LK', name: 'Sri Lanka', risk_score: 1 },
  { id: uuidv4(), code: 'US', name: 'Stati Uniti d\'America', risk_score: 1 },
  { id: uuidv4(), code: 'SZ', name: 'Swaziland', risk_score: 1 },
  { id: uuidv4(), code: 'ZA', name: 'Sudafrica', risk_score: 5 },
  { id: uuidv4(), code: 'SD', name: 'Sudan', risk_score: 5 },
  { id: uuidv4(), code: 'SS', name: 'Sud Sudan', risk_score: 5 },
  { id: uuidv4(), code: 'SE', name: 'Svezia', risk_score: 1 },
  { id: uuidv4(), code: 'CH', name: 'Svizzera', risk_score: 1 },
  { id: uuidv4(), code: 'SR', name: 'Suriname', risk_score: 1 },
  { id: uuidv4(), code: 'TH', name: 'Thailandia', risk_score: 3 },
  { id: uuidv4(), code: 'TW', name: 'Taiwan', risk_score: 1 },
  { id: uuidv4(), code: 'TZ', name: 'Tanzania', risk_score: 5 },
  { id: uuidv4(), code: 'TJ', name: 'Tagikistan', risk_score: 1 },
  { id: uuidv4(), code: 'TL', name: 'Timor Est', risk_score: 1 },
  { id: uuidv4(), code: 'TG', name: 'Togo', risk_score: 1 },
  { id: uuidv4(), code: 'TO', name: 'Tonga', risk_score: 1 },
  { id: uuidv4(), code: 'TT', name: 'Trinidad e Tobago', risk_score: 5 },
  { id: uuidv4(), code: 'TN', name: 'Tunisia', risk_score: 3 },
  { id: uuidv4(), code: 'TR', name: 'Turchia', risk_score: 3 },
  { id: uuidv4(), code: 'TM', name: 'Turkmenistan', risk_score: 1 },
  { id: uuidv4(), code: 'UA', name: 'Ucraina', risk_score: 3 },
  { id: uuidv4(), code: 'UG', name: 'Uganda', risk_score: 3 },
  { id: uuidv4(), code: 'HU', name: 'Ungheria', risk_score: 1 },
  { id: uuidv4(), code: 'UY', name: 'Uruguay', risk_score: 1 },
  { id: uuidv4(), code: 'UZ', name: 'Uzbekistan', risk_score: 1 },
  { id: uuidv4(), code: 'VU', name: 'Vanuatu', risk_score: 5 },
  { id: uuidv4(), code: 'VE', name: 'Venezuela', risk_score: 5 },
  { id: uuidv4(), code: 'VN', name: 'Vietnam', risk_score: 5 },
  { id: uuidv4(), code: 'YE', name: 'Yemen', risk_score: 5 },
  { id: uuidv4(), code: 'ZM', name: 'Zambia', risk_score: 3 },
  { id: uuidv4(), code: 'ZW', name: 'Zimbabwe', risk_score: 3 },
]);

const ITALIAN_PROVINCES = Object.freeze([
  { id: uuidv4(), code: 'AG', name: 'Agrigento', risk_score: 3 },
  { id: uuidv4(), code: 'AL', name: 'Alessandria', risk_score: 1 },
  { id: uuidv4(), code: 'AN', name: 'Ancona', risk_score: 1 },
  { id: uuidv4(), code: 'AO', name: 'Aosta', risk_score: 1 },
  { id: uuidv4(), code: 'AR', name: 'Arezzo', risk_score: 3 },
  { id: uuidv4(), code: 'AP', name: 'Ascoli Piceno', risk_score: 1 },
  { id: uuidv4(), code: 'AT', name: 'Asti', risk_score: 1 },
  { id: uuidv4(), code: 'AV', name: 'Avellino', risk_score: 3 },
  { id: uuidv4(), code: 'BA', name: 'Bari', risk_score: 5 },
  { id: uuidv4(), code: 'BT', name: 'Barletta-Andria-Trani', risk_score: 1 },
  { id: uuidv4(), code: 'BL', name: 'Belluno', risk_score: 1 },
  { id: uuidv4(), code: 'BN', name: 'Benevento', risk_score: 1 },
  { id: uuidv4(), code: 'BG', name: 'Bergamo', risk_score: 1 },
  { id: uuidv4(), code: 'BI', name: 'Biella', risk_score: 1 },
  { id: uuidv4(), code: 'BO', name: 'Bologna', risk_score: 1 },
  { id: uuidv4(), code: 'BZ', name: 'Bolzano', risk_score: 1 },
  { id: uuidv4(), code: 'BS', name: 'Brescia', risk_score: 1 },
  { id: uuidv4(), code: 'BR', name: 'Brindisi', risk_score: 3 },
  { id: uuidv4(), code: 'CA', name: 'Cagliari', risk_score: 1 },
  { id: uuidv4(), code: 'CL', name: 'Caltanissetta', risk_score: 3 },
  { id: uuidv4(), code: 'CB', name: 'Campobasso', risk_score: 1 },
  { id: uuidv4(), code: 'CE', name: 'Caserta', risk_score: 5 },
  { id: uuidv4(), code: 'CT', name: 'Catania', risk_score: 3 },
  { id: uuidv4(), code: 'CZ', name: 'Catanzaro', risk_score: 5 },
  { id: uuidv4(), code: 'CH', name: 'Chieti', risk_score: 1 },
  { id: uuidv4(), code: 'CO', name: 'Como', risk_score: 1 },
  { id: uuidv4(), code: 'CS', name: 'Cosenza', risk_score: 5 },
  { id: uuidv4(), code: 'CR', name: 'Cremona', risk_score: 1 },
  { id: uuidv4(), code: 'KR', name: 'Crotone', risk_score: 5 },
  { id: uuidv4(), code: 'CN', name: 'Cuneo', risk_score: 1 },
  { id: uuidv4(), code: 'EN', name: 'Enna', risk_score: 5 },
  { id: uuidv4(), code: 'FM', name: 'Fermo', risk_score: 1 },
  { id: uuidv4(), code: 'FE', name: 'Ferrara', risk_score: 1 },
  { id: uuidv4(), code: 'FI', name: 'Firenze', risk_score: 1 },
  { id: uuidv4(), code: 'FG', name: 'Foggia', risk_score: 1 },
  { id: uuidv4(), code: 'FC', name: 'Forlì-Cesena', risk_score: 1 },
  { id: uuidv4(), code: 'FR', name: 'Frosinone', risk_score: 1 },
  { id: uuidv4(), code: 'GE', name: 'Genova', risk_score: 1 },
  { id: uuidv4(), code: 'GO', name: 'Gorizia', risk_score: 1 },
  { id: uuidv4(), code: 'GR', name: 'Grosseto', risk_score: 1 },
  { id: uuidv4(), code: 'IM', name: 'Imperia', risk_score: 1 },
  { id: uuidv4(), code: 'IS', name: 'Isernia', risk_score: 3 },
  { id: uuidv4(), code: 'AQ', name: 'L\'Aquila', risk_score: 1 },
  { id: uuidv4(), code: 'SP', name: 'La Spezia', risk_score: 1 },
  { id: uuidv4(), code: 'LT', name: 'Latina', risk_score: 3 },
  { id: uuidv4(), code: 'LE', name: 'Lecce', risk_score: 3 },
  { id: uuidv4(), code: 'LC', name: 'Lecco', risk_score: 1 },
  { id: uuidv4(), code: 'LI', name: 'Livorno', risk_score: 1 },
  { id: uuidv4(), code: 'LO', name: 'Lodi', risk_score: 1 },
  { id: uuidv4(), code: 'LU', name: 'Lucca', risk_score: 1 },
  { id: uuidv4(), code: 'MC', name: 'Macerata', risk_score: 1 },
  { id: uuidv4(), code: 'MN', name: 'Mantova', risk_score: 1 },
  { id: uuidv4(), code: 'MS', name: 'Massa-Carrara', risk_score: 1 },
  { id: uuidv4(), code: 'MT', name: 'Matera', risk_score: 5 },
  { id: uuidv4(), code: 'ME', name: 'Messina', risk_score: 5 },
  { id: uuidv4(), code: 'MI', name: 'Milano', risk_score: 1 },
  { id: uuidv4(), code: 'MO', name: 'Modena', risk_score: 1 },
  { id: uuidv4(), code: 'MB', name: 'Monza e Brianza', risk_score: 1 },
  { id: uuidv4(), code: 'NA', name: 'Napoli', risk_score: 5 },
  { id: uuidv4(), code: 'NO', name: 'Novara', risk_score: 1 },
  { id: uuidv4(), code: 'NU', name: 'Nuoro', risk_score: 1 },
  { id: uuidv4(), code: 'OR', name: 'Oristano', risk_score: 3 },
  { id: uuidv4(), code: 'PD', name: 'Padova', risk_score: 1 },
  { id: uuidv4(), code: 'PA', name: 'Palermo', risk_score: 1 },
  { id: uuidv4(), code: 'PR', name: 'Parma', risk_score: 1 },
  { id: uuidv4(), code: 'PV', name: 'Pavia', risk_score: 1 },
  { id: uuidv4(), code: 'PG', name: 'Perugia', risk_score: 1 },
  { id: uuidv4(), code: 'PU', name: 'Pesaro e Urbino', risk_score: 1 },
  { id: uuidv4(), code: 'PE', name: 'Pescara', risk_score: 1 },
  { id: uuidv4(), code: 'PC', name: 'Piacenza', risk_score: 1 },
  { id: uuidv4(), code: 'PI', name: 'Pisa', risk_score: 1 },
  { id: uuidv4(), code: 'PT', name: 'Pistoia', risk_score: 1 },
  { id: uuidv4(), code: 'PN', name: 'Pordenone', risk_score: 1 },
  { id: uuidv4(), code: 'PZ', name: 'Potenza', risk_score: 1 },
  { id: uuidv4(), code: 'PO', name: 'Prato', risk_score: 1 },
  { id: uuidv4(), code: 'RG', name: 'Ragusa', risk_score: 3 },
  { id: uuidv4(), code: 'RA', name: 'Ravenna', risk_score: 1 },
  { id: uuidv4(), code: 'RC', name: 'Reggio Calabria', risk_score: 5 },
  { id: uuidv4(), code: 'RE', name: 'Reggio Emilia', risk_score: 1 },
  { id: uuidv4(), code: 'RI', name: 'Rieti', risk_score: 1 },
  { id: uuidv4(), code: 'RN', name: 'Rimini', risk_score: 1 },
  { id: uuidv4(), code: 'RM', name: 'Roma', risk_score: 1 },
  { id: uuidv4(), code: 'RO', name: 'Rovigo', risk_score: 1 },
  { id: uuidv4(), code: 'SA', name: 'Salerno', risk_score: 5 },
  { id: uuidv4(), code: 'SS', name: 'Sassari', risk_score: 1 },
  { id: uuidv4(), code: 'SV', name: 'Savona', risk_score: 1 },
  { id: uuidv4(), code: 'SI', name: 'Siena', risk_score: 1 },
  { id: uuidv4(), code: 'SR', name: 'Siracusa', risk_score: 5 },
  { id: uuidv4(), code: 'SO', name: 'Sondrio', risk_score: 1 },
  { id: uuidv4(), code: 'SU', name: 'Sud Sardegna', risk_score: 1 },
  { id: uuidv4(), code: 'TA', name: 'Taranto', risk_score: 1 },
  { id: uuidv4(), code: 'TE', name: 'Teramo', risk_score: 3 },
  { id: uuidv4(), code: 'TR', name: 'Terni', risk_score: 1 },
  { id: uuidv4(), code: 'TO', name: 'Torino', risk_score: 1 },
  { id: uuidv4(), code: 'TP', name: 'Trapani', risk_score: 5 },
  { id: uuidv4(), code: 'TN', name: 'Trento', risk_score: 1 },
  { id: uuidv4(), code: 'TV', name: 'Treviso', risk_score: 1 },
  { id: uuidv4(), code: 'TS', name: 'Trieste', risk_score: 1 },
  { id: uuidv4(), code: 'UD', name: 'Udine', risk_score: 1 },
  { id: uuidv4(), code: 'VA', name: 'Varese', risk_score: 1 },
  { id: uuidv4(), code: 'VE', name: 'Venezia', risk_score: 1 },
  { id: uuidv4(), code: 'VB', name: 'Verbano-Cusio-Ossola', risk_score: 1 },
  { id: uuidv4(), code: 'VC', name: 'Vercelli', risk_score: 1 },
  { id: uuidv4(), code: 'VR', name: 'Verona', risk_score: 1 },
  { id: uuidv4(), code: 'VV', name: 'Vibo Valentia', risk_score: 1 },
  { id: uuidv4(), code: 'VI', name: 'Vicenza', risk_score: 1 },
  { id: uuidv4(), code: 'VT', name: 'Viterbo', risk_score: 1 },
]);

const ANNUAL_INCOME = Object.freeze([
  { id: uuidv4(), value: 'Inferiore a 50.000 €', risk_score: 1 },
  { id: uuidv4(), value: '50.000 - 200.000 €', risk_score: 3 },
  { id: uuidv4(), value: 'Oltre 200.000 €', risk_score: 5 },
]);

const PERSONAL_ASSETS = Object.freeze([
  { id: uuidv4(), value: 'Inferiore a 500.000 €', risk_score: 1 },
  { id: uuidv4(), value: '500.000 - 1.000.000 €', risk_score: 3 },
  { id: uuidv4(), value: 'Oltre 1.000.000 €', risk_score: 5 },
]);

const FUNDS_ORIGIN = Object.freeze([
  { id: uuidv4(), value: 'Redditi da lavoro/Pensione', risk_score: 1 },
  { id: uuidv4(), value: 'Risparmi personali', risk_score: 1 },
  { id: uuidv4(), value: 'Prestito bancario', risk_score: 1 },
  { id: uuidv4(), value: 'Donazione familiare', risk_score: 3 },
  { id: uuidv4(), value: 'Vendita di beni/Proprietà', risk_score: 3 },
  { id: uuidv4(), value: 'Eredità', risk_score: 3 },
  { id: uuidv4(), value: 'Redditi da attività d\'impresa', risk_score: 3 },
  { id: uuidv4(), value: 'Proventi da investimenti finanziari', risk_score: 3 },
  { id: uuidv4(), value: 'Vincita gioco d\'azzardo/Lotteria', risk_score: 5 },
  { id: uuidv4(), value: 'Proventi da Criptovalute', risk_score: 5 },
  {
    id: uuidv4(),
    value: 'Fondi da paesi offshore/Paradisi fiscali',
    risk_score: 5,
  },
]);

const PEP = Object.freeze([
  { id: uuidv4(), value: 'No (non presente in liste)', risk_score: 1 },
  { id: uuidv4(), value: 'Sì (presente in lista di controllo)', risk_score: 5 },
]);

export default Object.freeze({
  ANNUAL_INCOME,
  APPROVAL_KEY,
  DUE_DILIGENCE_STATUS,
  FUNDS_ORIGIN,
  GEOGRAPHICAL_AREA,
  ITALIAN_PROVINCES,
  OPENING_ACCOUNT_REASONS,
  PEP,
  PERSONAL_ASSETS,
  RISK_LEVEL,
  WORK_SECTORS,
  WORK_TYPES,
});
